// src/App.js
import { useState, useEffect } from 'react';
import './App.css';
import Timer from "./components/Timer";
import GameBoard from "./components/GameBoard";
import WinnerGameBoard from "./components/WinnerGameBoard";
import ResultsCalculator from "./components/ResultsCalculator";

// 📅 Fin du jeu 1 à 19h
const GAME1_END_DATE = "2026-02-13T19:00:00";

function App() {
  // 🔒 Hooks toujours appelés en premier
  const [isGame1Open, setIsGame1Open] = useState(true);

  useEffect(() => {
    checkGameStatus();
  }, []);

  const pathname = window.location.pathname;
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const checkGameStatus = () => {
    const now = new Date();
    const game1End = new Date(GAME1_END_DATE);

    setIsGame1Open(now < game1End);
  };

  // 🔹 PAGE RÉSULTATS (LOCAL UNIQUEMENT)
  if (pathname === "/results" && isLocalhost) {
    return <ResultsCalculator />;
  }

  // 🔹 PAGE PRINCIPALE (JEU 1 ou JEU 2)
  return (
    <div className="App" style={{ padding: 16, maxWidth: 720, margin: '0 auto' }}>
      
      {isGame1Open ? (
        <>
          <h1 style={{ fontSize: 20, marginBottom: 16 }}>
            Il est temps de parier sur qui est qui !
          </h1>

          {/* Timer visible uniquement pour jeu 1 */}
          <Timer endDate={GAME1_END_DATE} />

          <GameBoard isVotingOpen={true} />
        </>
      ) : (
        <>
          <h1 style={{ fontSize: 20, marginBottom: 16 }}>
            Il est temps de parier sur qui gagnera le Royal Rumble !
          </h1>

          <WinnerGameBoard />
        </>
      )}

      {/* FOOTER */}
      <footer className="app-footer" style={{ marginTop: 20 }}>
        Site créé par Tiphanie Sempot
      </footer>
    </div>
  );
}

export default App;